// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdlistPickerController from "./adlist_picker_controller"
application.register("adlist-picker", AdlistPickerController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import RubyWasmController from "./ruby_wasm_controller"
application.register("ruby-wasm", RubyWasmController)

import TableFontSizeController from "./table_font_size_controller"
application.register("table-font-size", TableFontSizeController)

import UpdatedAtToggleController from "./updated_at_toggle_controller"
application.register("updated-at-toggle", UpdatedAtToggleController)
